import { GET_GL_ACCOUNTS } from '../../index.types';

export function getGLAccounts(data) {
    return {
        type: GET_GL_ACCOUNTS,
        data
    }
}
